import MaterialModal from '@mui/material/Modal';
import clsx from 'clsx';
import React, { ReactNode } from 'react';
import styles from './Modal.module.scss';

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  open: boolean;
  footer?: ReactNode;
  closeBtn?: boolean;
  contentRef?: any;
  containerProps?: React.HTMLAttributes<HTMLDivElement>;
  onClose?: (
    reason: 'backdropClick' | 'escapeKeyDown' | 'closeBtnClick'
  ) => void;
}

export default function Modal(props: Props) {
  if (!props.open) return null;

  return (
    <MaterialModal
      open
      className={styles.modalContainer}
      onClick={(e) => e.stopPropagation()}
      onTouchEnd={(e) => e.stopPropagation()}
      onClose={(_, reason) => props.onClose?.(reason)}
    >
      <div
        {...props.containerProps}
        className={clsx(styles.container, props.containerProps?.className)}
      >
        <h2 className={styles.title}>
          {props.title}
          {props.closeBtn && (
            <button
              className={styles.closeBtn}
              type="button"
              onClick={() => props.onClose?.('closeBtnClick')}
            >
              <i className="fonticons fonticons-x" />
            </button>
          )}
        </h2>
        <div
          id="modal-container"
          className={styles.content}
          ref={props.contentRef}
        >
          {props.children}
        </div>
        {props.footer && <div className={styles.footer}>{props.footer}</div>}
      </div>
    </MaterialModal>
  );
}
